export const ManageSubscriptionModal: string = 'ManageSubscriptionModal';
